import { render } from "./RuiSettings.vue?vue&type=template&id=22b1d5cd"
const script = {}
script.render = render

export default script